import script from "./replyTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./replyTime.vue?vue&type=script&setup=true&lang=ts"

import "./replyTime.vue?vue&type=style&index=0&id=58c1e85e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c1e85e"]])

export default __exports__